import { create } from 'zustand'
import McDataServices from '../services/McDataServices'

const useAdminStore = create((set, get) => ({
  activities: [],
  loading: false,
  error: null,
  totalElements: 0,
  totalPages: 1,
  page: 0,
  size: 10,
  sort: 'createdAt,desc',
  filters: {
    username: ''
  },
  users: [],
  usersLoading: false,
  usersTotalElements: 0,
  usersTotalPages: 1,
  usersPage: 0,
  usersSize: 10,
  usersSort: '',
  usersFilters: {
    username: ''
  },

  actions: {
    setLoading: (loading) => set({ loading }),
    setError: (error) => set({ error }),
    setActivities: (activities) => set({ activities }),
    setPagination: (page, totalElements, totalPages) => set({ page, totalElements, totalPages }),
    setPage: (page) => {
      set({ page })
      get().actions.fetchActivities()
    },
    setSize: (size) => {
      set({ size, page: 0 })
      get().actions.fetchActivities()
    },
    setFilters: (filters) => {
      set((state) => ({
        filters: { ...state.filters, ...filters },
        page: 0
      }))
      get().actions.fetchActivities()
    },
    setSort: (sort) => {
      set({ sort })
      get().actions.fetchActivities()
    },
    setUsersPage: (usersPage) => {
      set({ usersPage })
      get().actions.fetchUsers()
    },
    setUsersSize: (usersSize) => {
      set({ usersSize, usersPage: 0 })
      get().actions.fetchUsers()
    },
    setUsersFilters: (usersFilters) => {
      set((state) => ({
        usersFilters: { ...state.usersFilters, ...usersFilters },
        usersPage: 0
      }))
      get().actions.fetchUsers()
    },
    setUsersSort: (usersSort) => {
      set({ usersSort })
      get().actions.fetchUsers()
    },
    fetchActivities: async () => {
      const { page, size, sort, filters } = get()
      set({ loading: true, error: null })

      const payload = {
        page,
        size,
        sort,
        ...filters
      }

      Object.keys(payload).forEach(key => {
        if (payload[key] === '' || payload[key] === null || payload[key] === undefined) {
          delete payload[key]
        }
      })

      try {
        const response = await McDataServices.getActivities(payload)
        set({
          activities: response.content,
          totalElements: response.totalElements,
          totalPages: response.totalPages,
          loading: false
        })
      } catch (error) {
        set({ error: error?.detail || 'An error occurred', loading: false })
      }
    },
    fetchUsers: async () => {
      const { usersPage, usersSize, usersSort, usersFilters } = get()
      set({ usersLoading: true, error: null })

      const payload = {
        page: usersPage,
        pageSize: usersSize,
        sort: usersSort,
        ...usersFilters
      }

      Object.keys(payload).forEach(key => {
        if (payload[key] === '' || payload[key] === null || payload[key] === undefined) {
          delete payload[key]
        }
      })

      try {
        const response = await McDataServices.getUsers(payload)
        const responseData = response.data || response;
        set({
          users: responseData.users || [],
          usersTotalElements: responseData.totalRecordCount || 0,
          usersTotalPages: responseData.maxPage || 1,
          usersLoading: false
        })
      } catch (error) {
        set({ error: error?.detail || 'An error occurred', usersLoading: false })
      }
    }
  }
}))

export const useAdminStoreActions = () => useAdminStore((state) => state.actions)
export const useAdminStoreData = {
  activities: () => useAdminStore((state) => state.activities),
  loading: () => useAdminStore((state) => state.loading),
  error: () => useAdminStore((state) => state.error),
  totalElements: () => useAdminStore((state) => state.totalElements),
  totalPages: () => useAdminStore((state) => state.totalPages),
  page: () => useAdminStore((state) => state.page),
  size: () => useAdminStore((state) => state.size),
  sort: () => useAdminStore((state) => state.sort),
  filters: () => useAdminStore((state) => state.filters),
  users: () => useAdminStore((state) => state.users),
  usersLoading: () => useAdminStore((state) => state.usersLoading),
  usersTotalElements: () => useAdminStore((state) => state.usersTotalElements),
  usersTotalPages: () => useAdminStore((state) => state.usersTotalPages),
  usersPage: () => useAdminStore((state) => state.usersPage),
  usersSize: () => useAdminStore((state) => state.usersSize),
  usersSort: () => useAdminStore((state) => state.usersSort),
  usersFilters: () => useAdminStore((state) => state.usersFilters)
}

export default useAdminStore
